import { useTheme } from "styled-components";

const useThemeName = () => useTheme().name;

export default useThemeName;
